import { drama } from '../../../constants/actionTypes';

const initState = [];

export default (state = initState, { type, result, commentId }) => {
  switch (type) {
    case drama.FETCH_DRAMA_COMMENTS_SUCCESS:
      return [...state, ...result];

    case drama.POST_DRAMA_COMMENT_SUCCESS:
      return [result, ...state];

    case drama.DELETE_DRAMA_COMMENT_SUCCESS: {
      return state.filter(id => id !== commentId);
    }

    case drama.CLEAN_COMMENTS:
      return initState;

    default:
      return state;
  }
};
